import * as React from "react"

function RightArrow(props) {
  return (
    <svg
      width={14}
      height={24}
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1l11 11L1 23"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default RightArrow
